var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('h1',[_vm._v("404 Not Found")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }